// extracted by mini-css-extract-plugin
module.exports = {"notFoundPage":"_404-module--not-found-page--2HTPQ"};